<ion-list class="block-content-round no-padding ion-margin-bottom">
  <ion-grid class="">
    <ion-row class="ion-no-padding">
      <ion-col
        size="12"
        class="ion-no-padding"
      >
        @if (!canCreateAsCarrier() && !canCreateAsShipper()) {
          <p class="fs-sm ion-text-center">No tiene permisos para generar un nuevo documento de control.</p>
        } @else if (soleRole() === DECA_ROLE.CARRIER) {
          <ion-list class="ion-margin-top">
            <ion-item lines="none">
              <ion-icon
                aria-hidden="true"
                src="../assets/material-symbols/local_shipping_24dp.svg"
                slot="start"
              ></ion-icon>
              <ion-label>Soy el transportista efectivo</ion-label>
            </ion-item>
          </ion-list>
        } @else if (soleRole() === DECA_ROLE.SHIPPER) {
          <ion-list class="ion-margin-top">
            <ion-item lines="none">
              <ion-icon
                aria-hidden="true"
                src="../assets/material-symbols/box_24dp.svg"
                slot="start"
              ></ion-icon>
              <ion-label>Soy el cargador contractual</ion-label>
            </ion-item>
          </ion-list>
        } @else {
          <!-- <p class="fs-sm">Seleccione si en este documento de control es transportista o cargador.</p> -->

          <ion-radio-group
            class="ion-margin-top"
            [value]="selectedRole()"
            (ionChange)="onRoleChange($event)"
          >
            <ion-grid class="ion-no-padding">
              <ion-row>
                @if (canCreateAsCarrier()) {
                  <!-- <div class="ion-margin-start"> -->
                  <ion-col
                    size="12"
                    size-lg="6"
                  >
                    <ion-list>
                      <ion-item
                        [class.selected]="selectedRole() === DECA_ROLE.CARRIER"
                        lines="full"
                      >
                        <ion-icon
                          aria-hidden="true"
                          src="../assets/material-symbols/local_shipping_24dp.svg"
                          slot="start"
                        ></ion-icon>
                        <ion-radio
                          value="carrier"
                          labelPlacement="start"
                        >
                          Soy el transportista efectivo
                        </ion-radio>
                      </ion-item>
                    </ion-list>
                  </ion-col>
                  <!-- </div> -->
                }
                @if (canCreateAsShipper()) {
                  <!-- <div class="ion-margin-start"> -->
                  <ion-col
                    size="12"
                    size-lg="6"
                  >
                    <ion-list>
                      <ion-item
                        [class.selected]="selectedRole() === DECA_ROLE.SHIPPER"
                        lines="full"
                      >
                        <ion-icon
                          aria-hidden="true"
                          src="../assets/material-symbols/box_24dp.svg"
                          slot="start"
                        ></ion-icon>
                        <ion-radio
                          value="shipper"
                          labelPlacement="start"
                        >
                          Soy el cargador contractual
                        </ion-radio>
                      </ion-item>
                    </ion-list>
                  </ion-col>
                  <!-- </div> -->
                }
              </ion-row>
            </ion-grid>
          </ion-radio-group>
        }
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-list>

@if (selectedRole(); as role) {
  @if (document(); as doc) {
    <lib-deca-edit-host
      [document]="doc"
      [postSaveRoute]="postSaveRoute()"
      (formResetRequested)="resetRoleSelection()"
    ></lib-deca-edit-host>
  }
}
